import { groupTrackingLabelsByStatus, type OrderItemGroup } from '@cart-services/utils/official-website-order-shipments'
import { DISPLAY_STATUS, type DisplayStatusType } from '@constants'
import { type WpSubshipSetting } from '@hooks-api/types/dataModel/wp'
import { Paper } from '@pets-ui/Paper/Paper'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'
import { useTranslation } from 'react-i18next'
import { NoTrackingNumber } from './NoTrackingNumber'
import { OrderItems } from './OrderItems'
import { TrackingLabelSummary } from './TrackingLabelSummary'

interface OrderItemGroupOfficialWebsiteProps {
  index?: number
  orderItemGroup: OrderItemGroup
  subshipType?: WpSubshipSetting['type']
  displayStatus?: DisplayStatusType
}

export function OrderItemGroupOfficialWebsite({ index, orderItemGroup, subshipType, displayStatus }: OrderItemGroupOfficialWebsiteProps) {
  const { t } = useTranslation()
  const providerGroups = groupTrackingLabelsByStatus(orderItemGroup.trackingLabels)
  const isShipped = displayStatus === DISPLAY_STATUS.SHIPPED

  return (
    <Paper p={3}>
      <VStack gap={3}>
        <Text variant="subtitle">
          {`${t('orderDetail.shipmentOrder', { defaultValue: '出貨項目' })}${index != null ? ` ${index}` : ''}`}
        </Text>
        {isShipped && (providerGroups.length > 0
          ? providerGroups.map(providerGroup => (
            <TrackingLabelSummary key={providerGroup.provider} trackingLabelProviderGroup={providerGroup} />
          ))
          : <NoTrackingNumber />)}
        <OrderItems orderItems={orderItemGroup.orderItems} subshipType={subshipType} />
      </VStack>
    </Paper>
  )
}
